import arrowLeft from 'public/static/images/circle-arrow-left.png';
import arrowRight from 'public/static/images/circle-arrow-right.png';
import css from 'styled-jsx/css';

/* istanbul ignore next */
const slickCarouselCSS = css.resolve`
  /* Slick overrider
  */
  .slick-slider {
    height: 265px;
    overflow: hidden;
  }

  /* HACK:
          the dynamic calculation for this is always off, but since the max-size
          is never more than 3500px just hard code it.
          https://github.com/kenwheeler/slick/issues/790
          */
  .slick-slider :global(.slick-track) {
    width: 3500px !important;
  }

  .slick-slider :global(.slick-slide) {
    margin: 0 10px 25px 0;
  }

  .slick-slider :global(.slick-arrow) {
    position: absolute;
    z-index: 1;
    top: 87.5px;
    height: 35px;
    width: 35px;
    background-repeat: no-repeat;
    background-color: transparent;
    border: 0;
    cursor: pointer;
  }

  .slick-slider :global(.slick-arrow.slick-disabled) {
    display: none !important;
  }

  .slick-slider :global(.slick-next) {
    font-size: 0;
    right: 10px;
    background-repeat: no-repeat;
    background-image: url(${arrowRight});
  }

  .slick-slider :global(.slick-prev) {
    font-size: 0;
    left: 10px;
    background-image: url(${arrowLeft});
    background-repeat: no-repeat;
  }
`;

export default slickCarouselCSS;
